module.exports = __webpack_public_path__ + "img/headRight1Logo.d56e7ea1.png";